import { useEffect, useState } from 'react';
import { usePrevious } from 'app/infrastructure/hooks';
import { Configuration } from 'app/components/metro-line/types';
import { SubscriberGroupItemValidation } from '../types-store';
import { SubscriberGroupSectionType } from './types';

export const useInvalidSection = (
  configuration: Configuration<SubscriberGroupSectionType>[],
  validation: SubscriberGroupItemValidation
): [Configuration<SubscriberGroupSectionType>, React.Dispatch<React.SetStateAction<Configuration<SubscriberGroupSectionType>>>] => {

  const [invalidSection, updateInvalidSection] = useState(configuration.find(configurationSection => !configurationSection.isValid));
  const previousValidation = usePrevious(validation);

  useEffect(() => {
    if (invalidSection === undefined && validation !== previousValidation
    ) {
      updateInvalidSection(configuration.find(configurationSection => !configurationSection.isValid));
    }
  }, [configuration, validation]);

  return [invalidSection, updateInvalidSection];
};
